import { loadPackage } from "common/utils/package-loader";
import "flickity/css/flickity.css";

export default class FlickityClass {
  #flickity;

  #flickitySelector;

  #flickityOptions;

  #options;

  constructor(flickitySelector, flickityOptions, options = {}) {
    this.#flickitySelector = flickitySelector;
    this.#flickityOptions = flickityOptions;
    this.#options = options;
  }

  get flickity() {
    return this.#flickity;
  }

  get $flickity() {
    return document.querySelector(this.#flickitySelector);
  }

  async addOrModifyOptions(options) {
    this.#flickityOptions = { ...this.#flickityOptions, ...options };
    this.destroyFlickity();
    await this.initFlickity();
  }

  async initFlickity() {
    if (this.$flickity && !this.#flickity) {
      let FlickityConstructor;
      if (this.#options?.library) {
        FlickityConstructor = this.#options.library;
      } else {
        FlickityConstructor = await loadPackage("flickity-as-nav-for");
      }
      this.#flickity = new FlickityConstructor(this.#flickitySelector, this.#flickityOptions);
    }
  }

  destroyFlickity() {
    this.#flickity?.destroy();
    this.#flickity = undefined;
  }
}
